export interface DBRef {
  $ref: string;
  $id: any;
  $db?: string;
}

export interface DBDate {
  $date: string;
}

export type VisitorFunc = (
  val: unknown,
  fieldOrIndex: string,
  result: Record<string, unknown>,
  path: string,
  parent: Record<string, unknown>
) => void;

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class TypeUtils {
  static isPlainObject(val: any) {
    return val && typeof val === "object" && Object.getPrototypeOf(val) === Object.prototype;
  }

  static isDBRef(val: any): val is DBRef {
    return val && typeof val === "object" && typeof val.$ref === "string" && "$id" in val;
  }

  static isDBDate(val: any): val is DBDate {
    return val && typeof val === "object" && typeof val.$date === "string";
  }

  static visitObj(
    result: Record<string, unknown>,
    obj: any,
    visitFunction: VisitorFunc,
    parentPath: string,
    parent: Record<string, unknown>
  ): void {
    for (const [field, val] of Object.entries(obj)) {
      visitFunction(val, field, result, parentPath, parent);
    }
  }
}
